"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EmrLoginRequestSchema () {
        return EmrLoginRequestSchema;
    },
    get LoginMfaChallengeResponseSchema () {
        return LoginMfaChallengeResponseSchema;
    },
    get LoginMfaEnrollmentRequiredResponseSchema () {
        return LoginMfaEnrollmentRequiredResponseSchema;
    },
    get LoginRequestSchema () {
        return LoginRequestSchema;
    },
    get LoginResponseSchema () {
        return LoginResponseSchema;
    },
    get LoginTokenPairResponseSchema () {
        return LoginTokenPairResponseSchema;
    }
});
const _zod = require("zod");
const _email = require("./email");
const LoginRequestSchema = _zod.z.object({
    tenantSlug: _zod.z.string().min(1),
    email: _email.EmailAddressSchema,
    password: _zod.z.string().min(1)
});
const EmrLoginRequestSchema = _zod.z.object({
    email: _email.EmailAddressSchema,
    password: _zod.z.string().min(1)
}).strict();
const LoginTokenPairResponseSchema = _zod.z.object({
    accessToken: _zod.z.string().min(1),
    refreshToken: _zod.z.string().min(1),
    expiresIn: _zod.z.number().int().positive()
});
const LoginMfaChallengeResponseSchema = _zod.z.object({
    mfaRequired: _zod.z.literal(true),
    mfaToken: _zod.z.string().min(20)
});
const LoginMfaEnrollmentRequiredResponseSchema = _zod.z.object({
    mfaEnrollmentRequired: _zod.z.literal(true),
    enrollmentToken: _zod.z.string().min(20)
});
const LoginResponseSchema = _zod.z.union([
    LoginMfaChallengeResponseSchema,
    LoginMfaEnrollmentRequiredResponseSchema,
    LoginTokenPairResponseSchema
]);
